import styled from 'styled-components'

export const Container = styled.div`
    /* margin: 0 15px; */
    /* background-color: white; */
    width: 100%;
    flex: 1;
    /* border: 1px solid #f0f0f0; */
`